/**
 * Abre o chat do Côpi (Droz). O Footer (`enableCopiHelp: true` em
 * `layout.hook.ts`, via `@webmotors/consumer-shared-ui`) renderiza o botão
 * flutuante de ajuda (`[data-copi-help-button]`) — aqui apenas o acionamos.
 * Mantemos os ids legados do Droz (`#drz_btn_open`) como fallback.
 */
const openCopiChat = (): void => {
	const btn =
		window.document.querySelector<HTMLElement>('[data-copi-help-button]') ??
		window.document.querySelector<HTMLElement>('#drz_btn_open') ??
		window.document.querySelector<HTMLElement>('#drz_btn_open_updated');
	btn?.click();
};

export { openCopiChat };
